export default __webpack_public_path__ + "static/media/imran-author.b32492f9.png";